<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
     <snackBar></snackBar>
    <Loading
      :active.sync="isLoading"
      :color="color"
      :loader="loaderType"
      :is-full-page="false"
    ></Loading>
    <router-view></router-view>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";
import AppBar from "./components/AppBar";
import Drawer from "./components/drawer/Drawer";
import snackBar from "./components/SnakeBar";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "App",

  components: {
    Drawer,
    AppBar,
    HelloWorld,
    Loading,
    snackBar
    
    
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    axios.interceptors.request.use(
      (config) => {
        // trigger 'loading=true' event here
        this.isLoading = true;
        return config;
      },
      (error) => {
        this.isLoading = false;
        // trigger 'loading=false' event here
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        // trigger 'loading=false' event here
        this.isLoading = false;
        return response;
      },
      (error) => {
        this.isLoading = false;
        // trigger 'loading=false' event here
        return Promise.reject(error);
      }
    );
    window.baseURL = process.env.VUE_APP_BASE_URL;
  },

  data: () => ({
    color: "#9734fa",
    loaderType: "dots",
    isLoading: false,
  }),
};
</script>
<style lang="scss">
.scrolled {
  overflow: auto;
}
* {
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(117, 111, 111, 0.8);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
  &::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(78, 71, 71, 0.4);
  }
}

.drawer--title {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 64px;

  & .logo-link {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & img.logo {
    max-width: 180px;
    width: 100%;
  }
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 48px !important;
}
</style>
<style>
.ml-minus-18 {
  margin-left: -18px !important;
}
@media only screen and (min-width: 993px) {
  .d-flex.justify-space-between {
    display: flex !important;
  }
  .profile-link button {
    width: unset !important;
  }
  .setting-card .menu-box {
    width: 162px !important;
    height: 162px !important;
  }

  .setting-card div.row {
    margin: 40px !important;
  }
  .app-bar--title {
    font-size: 1.2rem !important;
  }
  .app-bar--subtitle {
    font-size: 0.7rem !important;
  }
  .logo img.img-fluid {
    width: 100% !important;
  }
  .login-form-img {
    min-height: 568px !important;
  }
}
@media only screen and (max-width: 992px) {
  .d-flex.justify-space-between {
    display: block !important;
  }
  .profile-link button {
    width: 98% !important;
  }
  .v-slide-group__prev.v-slide-group__prev--disabled {
    display: none !important;
  }
  .setting-card .menu-box {
    width: 130px !important;
    height: 130px !important;
  }
  .app-bar--title {
    font-size: 15px !important;
  }
  .app-bar--subtitle {
    font-size: 8px !important;
  }
  .logo img.img-fluid {
    width: 270px !important;
  }
  .login-form-img {
    min-height: 360px !important;
  }
}
</style>
